/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Container, HStack, Heading, IconButton } from '@mybridge/ui';
import React from 'react';
import { BackArrow, BackArrowRTL, EventSecondaryIcon } from '@mybridge/icons';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearEditEvent,
} from 'v4/store/actions/post.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
const EventsListingLayout = ({ children, displayHeader }) => {
  const router = useRouter();
  const { t } = useTranslator();
  const dispatch = useDispatch();
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const direction = useDirection();

  return (
    <Container maxW="1366px">
      <Head>
          <title>{loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''} myEvents | myBridge.me</title>
        </Head>
      {displayHeader && (
        <HStack w="100%" justifyContent={router.pathname === '/myevents/copy'?"space-between":"end"} pt={[2, 3]}>
          {router.pathname === '/myevents/copy' && <IconButton size="sm" variant="transparent" onClick={() => router.push('/myevents')} icon={direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />} />}
          <Button
            borderRadius="30px"
            variant="secondary"
            leftIcon={<EventSecondaryIcon />}
            color="#5B5B5B"
            onClick={() => {router.push('/myevents/create')
              dispatch(clearEditEvent());

            }}
            display={['none', 'none', 'flex']}
          >
            {t('myEvents.createNewEvent') || "Create new event"}
          </Button>
          <IconButton
            variant="secondary"
            icon={<EventSecondaryIcon />}
            color="#5B5B5B"
            onClick={() => router.push('/myevents/create')}
            display={['flex', 'flex', 'none']}
          />
        </HStack>
      )}

      {children}
    </Container>
  );
};

export default EventsListingLayout;
